var request = new XMLHttpRequest();
var requestgroups = new XMLHttpRequest();
var requestmodels = new XMLHttpRequest();
var requestblocks = new XMLHttpRequest();
var requestblockdetails = new XMLHttpRequest();
var requestparts = new XMLHttpRequest();

function handleImageError(image) {
    image.onerror = null; // Prevents infinite loop in case the default image also fails
    image.src = 'https://upload.wikimedia.org/wikipedia/commons/thumb/d/d1/Image_not_available.png/800px-Image_not_available.png?20210219185637'; // URL of your default image
}

function showPrefills() {
    var el = document.getElementsByClassName('modelsel_loop')[0];
    if (el.style.display === "none") {
      el.style.display = "block";
      console.log("Getting Selection Prefills");
      getGroups();
    } 
    document.getElementById("breadcrumb_block").style.display = "none";
    document.getElementById("breadcrumb_model").style.display = "none";
    var breadcrumb = document.getElementById("currentbreadcrumb");
  	breadcrumb.innerHTML = 'Model Select';
}


// Below function used to poplate the groups selections
function getGroups() {
    //https://hidden-peak-92987.herokuapp.com/WOT/getGroups
    var select = document.getElementById("groupsel");
    var length = select.options.length;
    for (i = length - 1; i >= 1; i--) {
        select.options[i] = null;
    }

    console.log("Running getGroups");
    console.log("URL Call is - /tools/partsearch/WOT/getGroups");
    requestgroups.open('GET', '/tools/partsearch/WOT/getGroups', true);
    requestgroups.onload = function() {
        // Begin accessing JSON data here
        var data = JSON.parse(this.response);
        var select = document.getElementById("groupsel");
        if (requestgroups.status >= 200 && requestgroups.status < 400) {
            window.blocks = data;
            console.log(window.blocks);
            for (var i = 0; i < data.length; i++) {
                var groupid = data[i].TMODELGROUP;
                var groupname = data[i].TDESCRIPTION;
                var el = document.createElement("option");
                el.textContent = groupname;
                el.value = groupid;
                select.appendChild(el);
            }
        } else {
            console.log('error');
        }
    }
    requestgroups.send()
}

// Below function used to poplate the models selections
function getModels(groupid) {
    //https://hidden-peak-92987.herokuapp.com/WOT/getModels/243212
    //var select = document.getElementById("groupsel");
    //var length = select.options.length;
    //for (i = length - 1; i >= 1; i--) {
    //    select.options[i] = null;
    //}
    
    var rangelist = document.getElementById("rangelist");
    
    rangelist.innerHTML = '<div class="collection-list__item-list" id="modellist"></div>'

    console.log("Running getModels");
    console.log("URL Call is - /tools/partsearch/WOT/getModels/" + groupid);
    requestmodels.open('GET', '/tools/partsearch/WOT/getModels/' + groupid, true);
    requestmodels.onload = function() {
        // Begin accessing JSON data here
        var data = JSON.parse(this.response);
        //var select = document.getElementById("groupsel");
        if (requestmodels.status >= 200 && requestmodels.status < 400) {
            window.blocks = data;
            console.log(window.blocks);
            for (var i = 0; i < data.length; i++) {
                var modelid = data[i].TMODTYP;
                var modelname = data[i].TMODNAME;
                var modelimage = data[i].TIMAGE;
                //var el = document.createElement("option");
                //el.textContent = groupname;
                //el.value = groupid;
                //select.appendChild(el);
                var modellist = document.getElementById("modellist");
                modellist.innerHTML += '<a href="?modelid=' + modelid + '&modelname=' + modelname + '&quantity=' + Date.now() + '" class="collection-list__item-wrapper collection-list__item-wrapper--overlay"><div class="aspect-ratio" style="padding-bottom:45%"><div class="collection-list__item-image image--fade-in lazyloaded" style="background-image:url(&quot;https://cdn.shopify.com/s/files/1/0345/2492/1988/files/' + modelimage + '&quot;)"></div></div><p class="collection-list__item-title heading h2">' + modelname + '</p></a>';
              console.log(modelid + modelname + modelimage);
            }
        } else {
            console.log('error');
        }
    }
    requestmodels.send()
  
}

// Below function used to poplate the blocks selections
function getBlocks(modelid,modelname) {
    document.getElementById("breadcrumb_block").style.display = "none";
    var breadcrumb = document.getElementById("currentbreadcrumb");
  	breadcrumb.innerHTML = 'Block Select';
  
    var rangelist = document.getElementById("rangelist");
    
    rangelist.innerHTML = '<p style="text-align:center" id="modelname">Current Model: <b>' + modelname + '</b></p><div class="collection-list__item-list" id="blocklist"></div>'

    console.log("Running getBlocks");
    console.log("URL Call is - /tools/partsearch/WOT/getBlocks/" + modelid);
    requestblocks.open('GET', '/tools/partsearch/WOT/getBlocks/' + modelid, true);
    requestblocks.onload = function() {
        // Begin accessing JSON data here
        var data = JSON.parse(this.response);
        //var select = document.getElementById("groupsel");
        if (requestblocks.status >= 200 && requestblocks.status < 400) {
            window.blocks = data;
            console.log(window.blocks);
            for (var i = 0; i < data.length; i++) {
                var blockid = data[i].partreferencegroupid;
                var blockname = data[i].groupdescription;
                var blocklist = document.getElementById("blocklist");
                blocklist.innerHTML += '<a href="?blockid=' + blockid + '&modelid=' + modelid + '&modelname=' + modelname + '&quantity=' + Date.now() + '" class="collection-list__item-wrapper collection-list__item-wrapper--overlay"><div class="aspect-ratio" style="padding-bottom:45%"><div class="collection-list__item-image image--fade-in lazyloaded" style="background-image:url(&quot;https://cdn.shopify.com/s/files/1/0345/2492/1988/files/WOT_'+blockid+'.png&quot;), url(https://cdn.shopify.com/s/files/1/0345/2492/1988/files/unavailable_image.jpg)" onerror="handleImageError(this)"></div></div><p class="collection-list__item-title heading h2">' + blockname + '</p></a>'
                console.log(modelid + blockid + blockname);
            }
        } else {
            console.log('error');
        }
    }
    requestblocks.send()
}


// Below function used to get block data for the grid on the selected block page
function getParts(blockid, modelid, modelname) {
    var blockcrumb = document.getElementById("breadcrumb_block");
    var breadcrumb = document.getElementById("currentbreadcrumb");
    blockcrumb.innerHTML = '<a class="breadcrumb__link link" href="/pages/parts-search?modelid=' + modelid + '&modelname=' + modelname + '&quantity=' + Date.now() + '">Block Select</a><svg class="icon icon--arrow-right" viewBox="0 0 8 12" role="presentation"> <path stroke="currentColor" stroke-width="2" d="M2 2l4 4-4 4" fill="none" stroke-linecap="square"></path> </svg>'
  	breadcrumb.innerHTML = 'Parts';
    
    var x = document.getElementById("sel_main");
    var y = document.getElementById("blocksel_res");
    if (x.style.display === "none") {
        x.style.display = "block";
        y.style.display = "block";
    } else {
        x.style.display = "none";
        y.style.display = "none";
    }
  
    console.log("URL Call is - /tools/partsearch/WOT/getBlockDetails/" + blockid + "/" + modelid);
    requestblockdetails.open('GET', '/tools/partsearch/WOT/getBlockDetails/' + blockid + "/" + modelid, true);
    requestblockdetails.onload = function() {
        // Begin accessing JSON data here
        var data = JSON.parse(this.response);
        if (requestblockdetails.status >= 200 && requestblockdetails.status < 400) {
            console.log(data);
            var BlockName = data.BlockName;
            var ModelName = data.ModelName;
            document.getElementById("blockmodelname").innerHTML = "Current Model: <b>" + ModelName + "</b>";
            document.getElementById("blockname").innerHTML = "Block: <b>" + BlockName + "</b>";
        } else {
            console.log('error');
        }
    }
    requestblockdetails.send()

    console.log("URL Call is - /tools/partsearch/WOT/getParts/" + blockid);
    requestparts.open('GET', '/tools/partsearch/WOT/getParts/' + blockid, true);
    requestparts.onload = function() {
        // Begin accessing JSON data here
        var data = JSON.parse(this.response);
        if (requestparts.status >= 200 && requestparts.status < 400) {
            window.blocksdetails = data;
            console.log(window.blocksdetails);
            for (var i = 0; i < data.length; i++) {
                var partref = data[i].Sequence;
                var partnumber = data[i].PartNumber;
                partnumber = partnumber.toUpperCase();
                var partqty = data[i].Quantity;
              
                var productlineitems = document.getElementById("productlineitems");
                productlineitems.innerHTML += '<tr id="tr-' + partnumber + '" style="display: none;"> <td data-label="Ref">' + partref + '</td> <td data-label="PartNo" class="PartNo-' + partnumber + '">' + partnumber + '</td> <td data-label="Description" id="descriptionitem-' + partnumber + '" class="descriptionitem-' + partnumber + '"></td> <td data-label="Price" id="priceitem-' + partnumber + '" class="priceitem-' + partnumber + '"></td> <td data-label="ReqQty" id="reqqtyitem-' + partnumber + '" class="reqqtyitem-' + partnumber + '">' + partqty + '</td> <td data-label="Cart"> <div id="product_form_id_' + partnumber + '_collection-blocks" class="product_form_id_' + partnumber + '_collection-blocks" class="product-item__action-list product-item__action-list--list-view-only button-stack" enctype="multipart/form-data"></div> </td> </tr>';
                
                FillShopifyPart(partnumber);
            }
        } else {
            console.log('error');
        }
    }
    requestparts.send()
}


function FillShopifyPart(partnumber) {

  var shopifysku = partnumber;
  console.log(shopifysku);
  
  
  window["request" + partnumber] = new XMLHttpRequest();
  window["request" + partnumber].open('GET', '/tools/partsearch/WOT/shopifyParts/' + partnumber, true)
  window["request" + partnumber].onload = function(partnumber) {
      
      // Begin accessing JSON data here
      var data = JSON.parse(this.response)
      console.log(data);
      if (data.data.productVariants.edges.length < 1 || data.data.productVariants.edges == undefined) {
          //empty
          //console.log("AHH NO PRODUCT");
          var partnumberdata = partnumber.currentTarget._url;
          var shopifysku = partnumber;
          //console.log(data);
          console.log(shopifysku);
          var pricelineitem = document.getElementById("priceitem-" + shopifysku);
          pricelineitem.innerHTML = "NA";
          var reqqty = document.getElementById("reqqtyitem-" + shopifysku);
          reqqty.innerHTML = "0";
          var addlineitem = document.getElementById("product_form_id_" + shopifysku + "_collection-blocks");
          addlineitem.innerHTML = '<div style="display:inline-block;"><button class="product-item__action-button product-item__action-button--list-view-only button button--small button--disabled" disabled="" style="margin-left: 10px; padding: 0px 15px 0px 15px; line-height:32px; top: 1px; width: 100%;">Unavailable</button></div>';
      } else {
          var idGIDString = "gid://shopify/ProductVariant/";
          var partID = data.data.productVariants.edges[0].node.id;
          var shopifyid = partID.replace(idGIDString, '');
          var shopifysku = data.data.productVariants.edges[0].node.sku;
          var shopifybarcode = data.data.productVariants.edges[0].node.barcode;
          var shopifyprice = data.data.productVariants.edges[0].node.price;
          var shopifytitle = data.data.productVariants.edges[0].node.product.title;
          var shopifydesc = data.data.productVariants.edges[0].node.product.description;
          //var shopifydesc = data.data.productVariants.edges[0].node.product.title;
          var shopifytags = data.data.productVariants.edges[0].node.product.tags;
          var shopifyinv = data.data.productVariants.edges[0].node.product.totalInventory;
          var shopifyinvignore = data.data.productVariants.edges[0].node.inventoryPolicy;
          //console.log(shopifytags);
          
          //console.log(shopifytitle);
          if (shopifydesc === "") {
              shopifydesc = shopifytitle;
          }
        
          //Check if no longer available
          if (shopifydesc.includes("NO LONGER AVAILABLE")) {
              shopifydesc = "NO LONGER AVAILABLE";
          }

          //console.log(shopifysku);
          //var desclineitem = document.getElementById("descriptionitem-"+ shopifysku);
          //desclineitem.innerHTML = shopifydesc;
          var x = document.getElementsByClassName("descriptionitem-" + shopifysku);
          var i;
          //console.log("Description is : " + shopifydesc);
          for (i = 0; i < x.length; i++) {
              shopifydesc = shopifydesc.replace(' | Genuine Triumph Motorcycle Part', '');
              shopifydesc = shopifydesc.replace(shopifysku + ' | ', '');
              shopifydesc = shopifydesc.replace(' - ' + shopifysku, '');
              shopifydesc = shopifydesc.replace(shopifysku, '');
              x[i].innerHTML = shopifydesc;
          }

          //var pricelineitem = document.getElementById("priceitem-"+ shopifysku);
          //pricelineitem.innerHTML = shopifyprice;
          var x = document.getElementsByClassName("priceitem-" + shopifysku);
          var i;
          for (i = 0; i < x.length; i++) {
              if (shopifydesc == "NO LONGER AVAILABLE") {
                  x[i].innerHTML = "NA";
              } else {
                  x[i].innerHTML = shopifyprice;
              }
          }

          var reqqty = document.getElementById("reqqtyitem-" + shopifysku).innerHTML;
          //var addlineitem = document.getElementById("product_form_id_"+ shopifysku +"_collection-blocks");

          var x = document.getElementsByClassName("reqqtyitem-" + shopifysku);
          var i;
          for (i = 0; i < x.length; i++) {
              if (shopifydesc == "NO LONGER AVAILABLE") {
                  x[i].innerHTML = 0;
              }
          }

          var x = document.getElementsByClassName("product_form_id_" + shopifysku + "_collection-blocks");
          var i;
          for (i = 0; i < x.length; i++) {
              //console.log(shopifydesc.includes("NO LONGER AVAILABLE"));
              //console.log(shopifyinvignore);
              if ((shopifyinv > 0 || shopifyinvignore == "CONTINUE") & shopifyprice > 0 & !shopifydesc.includes("NO LONGER AVAILABLE") & !shopifytags.includes("- unavailable -")) {
                  x[i].innerHTML = '<div style="display:block;"><input min="1" type="number" name="quantity" id="quantity-' + shopifyid + '" value="' + reqqty + '" style="padding: 0px 15px 0px 15px; line-height:32px; top: 1px; width:50%"><button class="product-item__action-button product-item__action-button--list-view-only button button--small button--primary" onclick="addItem(' + shopifyid + ')" style="padding: 0px 15px 0px 15px; line-height:32px; top: 1px;">Add</button></div>';
              } else {
                  x[i].innerHTML = '<div style="display:inline-block;"><button class="product-item__action-button product-item__action-button--list-view-only button button--small button--disabled" disabled="" style="margin-left: 10px; padding: 0px 15px 0px 15px; line-height:32px; top: 1px; width: 100%;">Unavailable</button></div>';
              }
          }
      }
      var x = document.getElementById("tr-" + shopifysku);
            if (x.style.display === "none") {
                x.style.display = "table-row";
            }
  }
  window["request" + partnumber].send()
}


async function addItem(shopifyid) {
    var quantity = document.getElementById("quantity-" + shopifyid).value;
    const result = await fetch("/cart/add.json", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        },
        body: JSON.stringify({
            id: shopifyid,
            quantity: quantity
        })
    });
    refreshcart(quantity);

}

function refreshcart(quantity) {
document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
    bubbles: true
  }));
  
document.documentElement.dispatchEvent(new CustomEvent('product:added', {
  bubbles: true,
  detail: {
    quantity: quantity
  }
}));
}